import uly from "ulysses/core";
import $ from "jquery";
import ko from "knockout";
import HalResource from "../api";

"use strict";
ko.bindingHandlers.checkbox = {
    init: function(element, va, bindings, model, context) {
        $(element).iCheck({
            checkboxClass: 'icheckbox_square-blue'
        }).on("ifChecked", function(e){
            var val = ko.unwrap(va());
            if (val !== true)
                va()(true);
        }).on("ifUnchecked", function(e){
            var val = ko.unwrap(va());
            if (val !== false )
                va()(false);
        });
    },
    update:function(element, va, bindings, model, context) {
        var val = ko.unwrap(va());
        if (val === true || val === "true")
            $(element).iCheck("check");
        else if (val === false || val === "false")
            $(element).iCheck("uncheck");
    }
};


//Below copied from https://github.com/faulknercs/Knockstrap (radioBinding)

// Knockout checked binding doesn't work with Bootstrap radio-buttons
ko.bindingHandlers.radio = {
    init: function (element, valueAccessor) {

        if (!ko.isObservable(valueAccessor())) {
            throw new Error(_("checkbox_radio_binding_should_be_used_only_with_observable_values", 'radio binding should be used only with observable values'));
        }

        $(element).on('change', 'input:radio', function (e) {
            // we need to handle change event after bootsrap will handle its event
            // to prevent incorrect changing of radio button styles
            setTimeout(function() {
                var radio = $(e.target),
                    value = valueAccessor(),
                    newValue = radio.val();

                // we shouldn't change value for disables buttons
                if (!radio.prop('disabled')) {
                    value(newValue);
                }
            }, 0);
        });
    },

    update: function (element, valueAccessor) {
        var value = ko.unwrap(valueAccessor()) || '',
            $radioButton = $(element).find('input[value="' + value.replace(/"/g, '\\"') + '"]'),
            $radioButtonWrapper;

        if ($radioButton.length) {
            $radioButtonWrapper = $radioButton.parent();

            $radioButtonWrapper.siblings().removeClass('active');
            $radioButtonWrapper.addClass('active');

            $radioButton.prop('checked', true);
        } else {
            $radioButtonWrapper = $(element).find('.active');
            $radioButtonWrapper.removeClass('active');
            $radioButtonWrapper.find('input').prop('checked', false);
        }
    }
};

ko.bindingHandlers.slidercheckbox = {
    init: function(elt, va, allbindings) {
        var obs = va();
        $(elt).on("change", function() {
            if (obs._locked)
                return;
            obs._locked = true;
            try {
                var is_two_state = ko.unwrap(allbindings().two_state);
                var val = elt.value;
                if (is_two_state) {
                    if (obs()) {
                        val = 1;
                        elt.value = 1;
                    } else {
                        val = 3;
                        elt.value = 3;
                    }
                }
                if (val == 1) {
                    obs(false);
                } else if (val == 2) {
                    obs(null);
                } else {
                    obs(true);
                }
            }
            finally {
                obs._locked = false;
            }

        })
    },
    update: function(elt, va, allbindings) {
        var value = ko.unwrap(va());
        var obs = va();
        var is_two_state = ko.unwrap(allbindings().two_state);
        if (obs._locked) {
            return;
        }
        obs._locked = true;
        try {
            if (value === true) {
                elt.value = 3;
            } else if (value === false) {
                elt.value = 1;
            } else if (is_two_state) {
                if (value) {
                    elt.value = 3;
                } else {
                    elt.value = 1;
                }
            } else elt.value = 2;
        }
        finally {
            obs._locked = false;
        }
    }
};
